import { BACKEND } from "../variables.js";
import axios from "axios";
const GET_BILLS_BY_HOUSE_URL = BACKEND + "/tenantBills/getBillsByHouse";
const GET_BILL_BY_BILL_ID_URL = BACKEND + "/tenantBills/getBillByBillId";
const GET_PENDING_BILLS_BY_HOUSE_URL =
  BACKEND + "/tenantBills/getUnpaidBillsByHouse";
const GET_BILLS_BY_TENANT_URL = BACKEND + "/tenantBills/getBillsByTenant";
const ADD_BILL_URL = BACKEND + "/tenantBills/add";
const UPDATE_BILL_URL = BACKEND + "/tenantBills/update";
const SEND_REMINDER_URL = BACKEND + "/tenantBills/remind";
const SET_BILL_EBM_URL = BACKEND + "/tenantBills/setEbm";
const GENERATE_BILLS_URL = BACKEND + "/tenantBills/generateBills";
const GET_MY_BILLS_URL = BACKEND + "/tenantBills/getMyBills";
const ADD_RECEIPT_URL = BACKEND + "/tenantBills/billDocuments/add";
const DELETE_RECEIPT_URL = BACKEND + "/tenantBills/billDocuments/delete";
const CONFIRM_BILL_URL = BACKEND + "/tenantBills/confirmPayment";
const UPDATE_LINE_PAYMENT_URL = BACKEND + "/tenantBills/updateLinePayment";
const CONFIRM_LINE_PAYMENTS_URL = BACKEND + "/tenantBills/confirmLinePayments";
const REJECT_PAYMENT_URL = BACKEND + "/tenantBills/rejectPayment";
const SUBMIT_PAYMENT_URL = BACKEND + "/tenantBills/submitPayment";
const REVOKE_BILL_URL = BACKEND + "/tenantBills/revokePayment";
const REVOKE_LINE_PAYMENTS_URL = BACKEND + "/tenantBills/revokeLinePayments";
const UPDATE_LINE_LABEL_URL = BACKEND + "/tenantBills/updateLineLabel";
const CANCEL_BILL_URL = BACKEND + "/tenantBills/cancel";

export default {
  state: {},
  getters: {},
  mutations: {},
  actions: {
    ["GET_BILLS_BY_HOUSE"](state, payload) {
      return axios({
        method: "POST",
        url: GET_BILLS_BY_HOUSE_URL,
        data: payload.data,
        headers: {
          Authorization: payload.token,
        },
      });
    },
    ["GET_BILL_BY_BILL_ID"](state, payload) {
      return axios({
        method: "POST",
        url: GET_BILL_BY_BILL_ID_URL,
        data: payload.data,
        headers: {
          Authorization: payload.token,
        },
      });
    },
    ["GET_PENDING_BILLS_BY_HOUSE"](state, payload) {
      return axios({
        method: "POST",
        url: GET_PENDING_BILLS_BY_HOUSE_URL,
        data: payload.data,
        headers: {
          Authorization: payload.token,
        },
      });
    },
    ["GET_BILLS_BY_TENANT"](state, payload) {
      return axios({
        method: "POST",
        url: GET_BILLS_BY_TENANT_URL,
        data: payload.data,
        headers: {
          Authorization: payload.token,
        },
      });
    },
    ["ADD_BILL"](state, payload) {
      return axios({
        method: "POST",
        url: ADD_BILL_URL,
        data: payload.data,
        headers: {
          Authorization: payload.token,
        },
      });
    },
    ["UPDATE_BILL"](state, payload) {
      return axios({
        method: "POST",
        url: UPDATE_BILL_URL,
        data: payload.data,
        headers: {
          Authorization: payload.token,
        },
      });
    },
    ["SEND_REMINDER"](state, payload) {
      return axios({
        method: "POST",
        url: SEND_REMINDER_URL,
        data: payload.data,
        headers: {
          Authorization: payload.token,
        },
      });
    },
    ["SET_BILL_EBM"](state, payload) {
      return axios({
        method: "POST",
        url: SET_BILL_EBM_URL,
        data: payload.data,
        headers: {
          Authorization: payload.token,
        },
      });
    },
    ["GENERATE_BILLS"](state, payload) {
      return axios({
        method: "POST",
        url: GENERATE_BILLS_URL,
        data: payload.data,
        headers: {
          Authorization: payload.token,
        },
      });
    },
    ["GET_MY_BILLS"](state, payload) {
      return axios({
        method: "POST",
        url: GET_MY_BILLS_URL + "?page=" + payload.data.page,
        data: payload.data,
        headers: {
          Authorization: payload.token,
        },
      });
    },
    ["ADD_RECEIPT"](state, payload) {
      return axios({
        method: "POST",
        url: ADD_RECEIPT_URL,
        data: payload.data,
        headers: {
          Authorization: payload.token,
        },
      });
    },
    ["DELETE_RECEIPT"](state, payload) {
      return axios({
        method: "POST",
        url: DELETE_RECEIPT_URL,
        data: payload.data,
        headers: {
          Authorization: payload.token,
        },
      });
    },
    ["CONFIRM_BILL"](state, payload) {
      return axios({
        method: "POST",
        url: CONFIRM_BILL_URL,
        data: payload.data,
        headers: {
          Authorization: payload.token,
        },
      });
    },
    ["UPDATE_LINE_PAYMENT"](state, payload) {
      return axios({
        method: "POST",
        url: UPDATE_LINE_PAYMENT_URL,
        data: payload.data,
        headers: { Authorization: payload.token },
      });
    },
    ["CONFIRM_LINE_PAYMENTS"](state, payload) {
      return axios({
        method: "POST",
        url: CONFIRM_LINE_PAYMENTS_URL,
        data: payload.data,
        headers: { Authorization: payload.token },
      });
    },
    ["REJECT_PAYMENT"](state, payload) {
      return axios({
        method: "POST",
        url: REJECT_PAYMENT_URL,
        data: payload.data,
        headers: {
          Authorization: payload.token,
        },
      });
    },
    ["SUBMIT_PAYMENT"](state, payload) {
      return axios({
        method: "POST",
        url: SUBMIT_PAYMENT_URL,
        data: payload.data,
        headers: {
          Authorization: payload.token,
        },
      });
    },
    ["REVOKE_BILL"](state, payload) {
      return axios({
        method: "POST",
        url: REVOKE_BILL_URL,
        data: payload.data,
        headers: {
          Authorization: payload.token,
        },
      });
    },
    ["REVOKE_LINE_PAYMENTS"](state, payload) {
      return axios({
        method: "POST",
        url: REVOKE_LINE_PAYMENTS_URL,
        data: payload.data,
        headers: {
          Authorization: payload.token,
        },
      });
    },
    ["UPDATE_LINE_LABEL"](state, payload) {
      return axios({
        method: "POST",
        url: UPDATE_LINE_LABEL_URL,
        data: payload.data,
        headers: {
          Authorization: payload.token,
        },
      });
    },
    ["CANCEL_BILL"](state, payload) {
      return axios({
        method: "POST",
        url: CANCEL_BILL_URL,
        data: payload.data,
        headers: {
          Authorization: payload.token,
        },
      });
    },
  },
};
